module.exports = __webpack_public_path__ + "assets/img/modal-avatar-f671ccf9.png";